import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { CatalogueService } from '../../services/catalogue.service'
import { of } from 'rxjs'
import { catchError, concatMap, map, withLatestFrom } from 'rxjs/operators'
import { CatalogueActions, CatalogueSelectors } from './catalogue-index'
import { CatalogueState } from './catalogue.state'

@Injectable()
export class CatalogueEffects {
  constructor(
    private catalogueService: CatalogueService,
    private actions$: Actions,
    private store: Store<CatalogueState>
  ) {}

  getCatalogue$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CatalogueActions.catalogueRequested),
      concatMap((action) =>
        of(action).pipe(
          withLatestFrom(this.store.select(CatalogueSelectors.selectCatalogues)),
          concatMap(([action, catalogues]) => {
            const hrid = action.hrid
            const catalogue = catalogues.find((catalogue) => catalogue.hrid === action.hrid)
            if (catalogue) {
              return of(CatalogueActions.catalogueRetrieved({ hrid, catalogue }))
            }

            return this.catalogueService.getCatalogueUncached(action.hrid).pipe(
              map((catalogue) => {
                return CatalogueActions.catalogueRetrieved({ hrid, catalogue })
              }),
              catchError(() => of(CatalogueActions.catalogueRequestFailed({ hrid })))
            )
          })
        )
      )
    )
  )
}
